"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = function _default() {
  return _react.default.createElement("svg", {
    height: 28,
    viewBox: "0 0 45.7 33.8",
    width: 28
  }, _react.default.createElement("path", {
    d: "M8.55 25.25l21.67-7.25H11zm2.41-9.47h19.26l-21.67-7.23zm-6 13l4-11.9L5 5l35.7 11.9z",
    clipRule: "evenodd"
  }));
};

exports.default = _default;